import React from "react";
import CustomButton from "../CustomButton";

function FormButtons({
  goBackLabel,
  goNextLabel,
  handleGoBack,
  handleGoNext,
  nextButtonDisabled,
  nextButtonLoading,
}: {
  goBackLabel?: string;
  goNextLabel?: string;
  handleGoBack?: () => void;
  handleGoNext?: () => void;
  nextButtonDisabled?: boolean;
  nextButtonLoading?: boolean;
}) {
  return (
    <div className="mt-6 flex flex-wrap justify-between gap-3">
      {goBackLabel && (
        <CustomButton
          variant="outlined"
          className="mr-2"
          onClick={handleGoBack}>
          {goBackLabel}
        </CustomButton>
      )}
      {goNextLabel && (
        <CustomButton
          variant="contained"
          className="mr-2"
          type="submit"
          disabled={nextButtonDisabled}
          loading={nextButtonLoading}
          onClick={handleGoNext}>
          {goNextLabel}
        </CustomButton>
      )}
    </div>
  );
}

export default FormButtons;
